'use client';

import { Stack, Text } from '@chakra-ui/react';
import { useTranslations } from 'next-intl';

import { Form } from '@packages/hook-form-wrapper';

export const ForgotPasswordForm = () => {
	const t = useTranslations('authentication.forgotPassword.form');

	return (
		<Stack gap="lg">
			<Stack gap="2xs" textAlign="center">
				<Text textStyle="bodyBold">
					{t('title')}
				</Text>
				<Text color="gray.100" textStyle="bodySmall">
					{t('description')}
				</Text>
			</Stack>
			<Form.TextInput
				label={t('fields.email.label')}
				name="email"
				placeholder={t('fields.email.placeholder')}
				size="lg"
			/>
			<Form.SubmitButton size="lg">
				{t('actions.submit')}
			</Form.SubmitButton>
		</Stack>
	);
};
